'use client';

import { useTranslations } from 'next-intl';
import { Loader } from '@/app/components/Loader';
import { UserPageHeader } from '@/app/components/UserPageHeader';
import { NotificationAuthorizations } from '@/types/user/enums';
import { NotificationSwitch } from './NotificationSwitch';

export const NotificationsForm = ({
  userSubscription,
  handleUpdateSubscription,
  isLoading = false,
}: {
  userSubscription: NotificationAuthorizations[];
  handleUpdateSubscription: (subscriptionList: NotificationAuthorizations[]) => void;
  isLoading?: boolean;
}) => {
  const t = useTranslations('SETTINGS.NOTIFICATION');

  const { NEW_SUBJECTS, COMMENT_ACTIVITY, ANNOUNCEMENT, MESSAGE }
    = NotificationAuthorizations;

  const notificationsTypes = [
    NEW_SUBJECTS,
    ANNOUNCEMENT,
    COMMENT_ACTIVITY,
    MESSAGE,
  ];

  return (
    <Loader loading={isLoading} size="large">
      <section
        className="unsubscribe-notifications"
        data-testid="notifications"
      >
        <UserPageHeader
          title={(
            <span>
              {t('TITLE')}
            </span>
          )}
          description={(
            <span>
              {t('SUBTITLE')}
            </span>
          )}
        />
        <div>
          {notificationsTypes.map(type => (
            <div
              key={type}
              className="profile__fieldgroup"
            >
              <NotificationSwitch
                type={type}
                handleUpdateSubscription={handleUpdateSubscription}
                userSubscription={userSubscription}
              />
            </div>
          ))}
        </div>
      </section>
    </Loader>
  );
};
